import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { BodyContainer, ButtonAdd, Header, TopGrid } from "../styles";
import Search from "../components/Search";
import DateField from "../components/DateField";
import DataTable from "react-data-table-component";
import add from "../../images/add.svg";
import AddEntry from "./AddEntry";
import DialogComponent from "../reusableComponents/Dialog";
import { useDispatch, useSelector } from "react-redux";
import { getVehicleReport } from "./vehicleReportSlice";
import moment from "moment";
import Loader from "../components/Loader";
import UpdateEntry from "./UpdateEntry";

const customStyles = {
  rows: {
    style: {
      minHeight: "42px",
      background: "white",
    },
  },
  header: {
    style: {
      color: "#4EAF50",
    },
  },
  headCells: {
    style: {
      justifyContent: "center",
      backgroundColor: "#4EAF50",
      fontStyle: "normal",
      color: "#FFFFFF",
      fontWeight: "500",
      fontSize: "12px",
      lineHeight: "18px",
    },
  },
  cells: {
    style: {
      justifyContent: "center",
      fontStyle: "normal",
      color: "#737373",
      fontWeight: "400",
      fontSize: "12px",
      lineHeight: "18px",
      borderLeft: "1px solid #4EAF51",
      borderBottom: "1px solid #4EAF51",
    },
  },
  table: {
    style: {
      background: "#EBEBEB",
      marginBottom: "20px",
      borderRight: "1px solid #4EAF51",
    },
  },
};
let obj = {
  company_code: localStorage.getItem("companyCode"),
  vehicleName: "",
  driverName: "",
  startDate: moment().format("DD-MM-YYYY"),
  endDate: moment().format("DD-MM-YYYY"),
};

function DailySheet() {
  const dispatch = useDispatch();
  const { vehicleReports, loading } = useSelector(
    (state) => state.vehicleReport
  );
  const [state, setState] = useState({
    loading: false,
    updateModal: false,
    addModal: false,
    selected: "",
    searchText: "",
    date: "",
    checkOut: 0,
  });

  const columns = [
    {
      name: "Vehicle",
      selector: (row) => row.vehicleName,
    },
    {
      name: "Driver",
      selector: (row) => row.driverName,
    },
    {
      name: "Meter Check-In",
      selector: (row) => row.checkIn,
    },
    {
      name: "Meter Check-Out",
      selector: (row) => {
        if (row.checkOut) {
          return row.checkOut;
        } else {
          return <Button onClick={() => handleRow(row)}>Update</Button>;
        }
      },
    },
    {
      name: "Distance KM",
      selector: (row) => row?.distance,
    },
    {
      name: "Fuel Avg",
      selector: (row) => row.fuelAverage,
    },
    {
      name: "Total Fuel Cost",
      selector: (row) => row?.totalCost,
    },
    {
      name: "Date",
      selector: (row) => row.date,
    },
  ];

  useEffect(() => {
    if (vehicleReports?.length == 0) {
      dispatch(getVehicleReport(obj));
    }
  }, []);

  const handleRow = (selected) => {
    setState((prev) => ({ ...prev, selected, updateModal: true }));
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name == "date") {
      setState((prev) => ({ ...prev, [name]: value }));
      if (value) {
        let d = moment(value).format("DD-MM-YYYY");
        dispatch(getVehicleReport({ ...obj, startDate: d, endDate: d }));
      }
    } else {
      setState((prev) => ({ ...prev, [name]: value }));
    }
  };
  const searchedItems = () => {
    if (state.searchText != "") {
      const filtered = vehicleReports.filter((item) =>
        item?.driverName.toLowerCase().includes(state.searchText)
      );
      return filtered;
    } else {
      return vehicleReports;
    }
  };

  const toggle = (name) => {
    setState((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  return (
    <Box>
      <Header sx={{ mt: { md: "0px", xs: "40px" } }}>
        <TopGrid container alignItems="center" spacing={1}>
          <Grid item md={3} xs={12}>
            <Search
              name={"searchText"}
              text={"Search item..."}
              value={state.searchText}
              onChange={handleInput}
            />
          </Grid>
          <Grid align="center" item lg={6} md={4} xs={12}>
            <Typography
              variant="h5"
              sx={{ color: "white", fontSize: { md: "1.5rem", xs: "16px" } }}
            >
              Vehicle Daily Sheet
            </Typography>
          </Grid>
          <Grid item lg={2} md={3} xs={7} sx={{ margin: "0 auto" }}>
            <DateField
              name={"date"}
              value={state.date}
              onChange={handleInput}
            />
          </Grid>
          <Grid item lg={1} md={2} xs={5} sx={{ margin: "0 auto" }}>
            <ButtonAdd variant="contained" onClick={() => toggle("addModal")}>
              Add <img src={add} alt="add" />
            </ButtonAdd>
          </Grid>
        </TopGrid>
      </Header>
      <BodyContainer
        sx={{ position: "relative", top: { md: "0px", xs: "40px" } }}
      >
        <DataTable
          columns={columns}
          data={searchedItems()}
          highlightOnHover={true}
          customStyles={customStyles}
          pointerOnHover={true}
        />
        <Loader loading={loading} />
      </BodyContainer>
      <DialogComponent
        title="Add Entry"
        open={state.addModal}
        onClose={() => toggle("addModal")}
        dialogContent={<AddEntry onClose={() => toggle("addModal")} />}
      />
      <DialogComponent
        title="Update Entry"
        open={state.updateModal}
        onClose={() => toggle("updateModal")}
        dialogContent={
          <UpdateEntry
            _id={state.selected._id}
            onClose={() => toggle("updateModal")}
          />
        }
      />
    </Box>
  );
}

export default DailySheet;
